(() => {
  if (window.DGStudioStorefront) return;
  window.DGStudioStorefront = true;
  // Delegated listeners also cover cards inserted by predictive search.
  let variantDrag = null;
  let suppressVariantClick = null;
  document.addEventListener('pointerdown', e => {
    suppressVariantClick = null;
    const row = e.target.closest('.sf-options');
    if (!row || e.pointerType !== 'mouse' || e.button !== 0 || row.scrollWidth <= row.clientWidth) return;
    variantDrag = {row, id:e.pointerId, x:e.clientX, left:row.scrollLeft, moved:false};
  });
  document.addEventListener('pointermove', e => {
    const drag = variantDrag;
    if (!drag || drag.id !== e.pointerId) return;
    const distance = e.clientX - drag.x;
    if (!drag.moved && Math.abs(distance) < 5) return;
    drag.moved = true;
    drag.row.classList.add('is-dragging');
    if (!drag.row.hasPointerCapture(e.pointerId)) drag.row.setPointerCapture(e.pointerId);
    drag.row.scrollLeft = drag.left - distance;
    e.preventDefault();
  });
  const finishVariantDrag = e => {
    const drag = variantDrag;
    if (!drag || drag.id !== e.pointerId) return;
    if (drag.moved) suppressVariantClick = drag.row;
    drag.row.classList.remove('is-dragging');
    if (drag.row.hasPointerCapture(e.pointerId)) drag.row.releasePointerCapture(e.pointerId);
    variantDrag = null;
  };
  document.addEventListener('pointerup', finishVariantDrag);
  document.addEventListener('pointercancel', finishVariantDrag);
  document.addEventListener('click', e => {
    if (e.detail !== 0 && suppressVariantClick?.contains(e.target)) {
      e.preventDefault(); e.stopImmediatePropagation(); suppressVariantClick = null;
    }
  }, true);
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const escape = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const root = window.Shopify?.routes?.root || '/';
  function headerState() { document.querySelectorAll('.sf-header-wrap:not([data-sf-not-sticky])').forEach(h => h.classList.toggle('is-scrolled', scrollY > 190)); }
  addEventListener('scroll', headerState, {passive:true});
  headerState();
  function init(scope = document) {
    scope.querySelectorAll('.sf-header').forEach(header=>{
      if(header.dataset.observed)return;header.dataset.observed='true';
      new ResizeObserver(()=>header.closest('.sf-header-wrap').classList.toggle('is-compact',header.clientWidth<1200)).observe(header);
    });
    scope.querySelectorAll('.sf-cart-count').forEach(count => {
      const update=()=>{count.dataset.empty=String(count.textContent.trim()==='0');};
      update();if(!count.dataset.observed){count.dataset.observed='true';new MutationObserver(update).observe(count,{childList:true,characterData:true,subtree:true});}
    });
    scope.querySelectorAll('[data-sf-search]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const input = form.querySelector('input'), results = form.querySelector('[data-sf-results]');
      let timer, controller, revision = 0;
      const hide = () => { results.hidden = true; input.setAttribute('aria-expanded','false'); };
      async function search() {
        const query = input.value.trim(), current = ++revision;
        controller?.abort();
        if (query.length < 2) return hide();
        let markup;
        try {
          if (window.DAMN_GOOD_CATALOG) {
            const products = window.DAMN_GOOD_CATALOG.filter(p => !p.tags.some(tag => String(tag).trim().toLowerCase() === 'tiktok')).filter(p => (p.title+' '+p.series+' '+p.tags.join(' ')).toLowerCase().includes(query.toLowerCase())).slice(0,4);
            markup = '<div class="sf-search-heading"><strong>Search results</strong><button type="button" data-sf-search-close aria-label="Close search">×</button></div><div class="sf-search-grid">'+(products.length ? products.map(p=>window.DGStudioCard(p)).join('') : '<p>'+escape(form.dataset.empty)+'</p>')+'</div>';
          }
          else {
            controller = new AbortController();
            const response = await fetch(root+'search/suggest?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&section_id=studio-predictive-search', {signal:controller.signal});
            if (!response.ok) throw new Error('Search unavailable');
            const document = new DOMParser().parseFromString(await response.text(),'text/html');
            const content = document.querySelector('[data-sf-predictive-content]');
            if(!content) throw new Error('Search template unavailable');
            markup = content.innerHTML;
          }
          if (current !== revision) return;
          results.innerHTML = markup;
          results.hidden = false; input.setAttribute('aria-expanded','true');
        } catch (e) { if (e.name !== 'AbortError') hide(); }
      }
      input.addEventListener('input', () => {clearTimeout(timer);revision++;controller?.abort();if(input.value.trim().length<2)hide();else timer = setTimeout(search,180);});
      results.addEventListener('click',e=>{if(e.target.closest('[data-sf-search-close]')){hide();input.focus();}});
      form.addEventListener('keydown', e => {
        if (e.key === 'Escape') {hide(); input.focus();}
        if (e.key === 'ArrowDown') {const links=[...results.querySelectorAll('a')]; if(links.length){e.preventDefault();links[(links.indexOf(document.activeElement)+1)%links.length].focus();}}
      });
      form.addEventListener('submit', e => {if(e.target.matches('.sf-search-box')&&window.DAMN_GOOD_CATALOG){e.preventDefault();search();}});
      document.addEventListener('click', e => {if(!form.contains(e.target))hide();});
    });
    scope.querySelectorAll('[data-sf-track]').forEach(track => {
      const section=track.closest('.sf-bestsellers');
      const update=()=>{const prev=section.querySelector('[data-sf-scroll="-1"]'),next=section.querySelector('[data-sf-scroll="1"]');if(prev)prev.disabled=track.scrollLeft<2;if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};
      if(!track.dataset.initialized){track.dataset.initialized='true';track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);}update();
    });
  }
  function select(card, id) {
    const choice=[...card.querySelectorAll('[data-sf-variant]')].find(b=>b.dataset.sfVariant===id);
    if(!choice) return;
    if(choice.getAttribute('aria-disabled')==='true') {choice.classList.remove('sf-jiggle');void choice.offsetWidth;choice.classList.add('sf-jiggle');return;}
    const buttons=[...card.querySelectorAll('[data-sf-variant]')];
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===choice)));
    card.querySelector('.sf-options').style.setProperty('--sf-index',buttons.indexOf(choice));
    card.querySelector('[name="id"]').value=id;
    card.querySelector('[name="quantity"]').value=choice.dataset.minimum || '1';
    card.querySelector('[data-sf-price]').textContent=choice.dataset.price;
    const legacySelect=card.querySelector('[data-sf-select]');if(legacySelect)legacySelect.value=id;
    card.querySelectorAll('[data-sf-product-link]').forEach(a=>a.href=choice.dataset.url);
    const add=card.querySelector('button[name="add"]');add.disabled=false;
  }
  document.addEventListener('click', e => {
    const opener=e.target.closest('[data-sf-open]');
    if(opener){const dialog=document.getElementById(opener.dataset.sfOpen);if(dialog){dialog.showModal();dialog.dataset.opener=opener.id;}}
    const closer=e.target.closest('[data-sf-close]');if(closer)closer.closest('dialog').close();
    const variant=e.target.closest('[data-sf-variant]');if(variant)select(variant.closest('.sf-card'),variant.dataset.sfVariant);
    const scroll=e.target.closest('[data-sf-scroll]');if(scroll){const track=scroll.closest('.sf-bestsellers').querySelector('[data-sf-track]');track.scrollBy({left:track.clientWidth*.75*Number(scroll.dataset.sfScroll),behavior:reduced()?'auto':'smooth'});}
    const menuLink=e.target.closest('.sf-menu-dialog nav a');if(menuLink)menuLink.closest('dialog').close();
  });
  document.addEventListener('change',e=>{if(e.target.matches('[data-sf-select]'))select(e.target.closest('.sf-card'),e.target.value);});
  document.querySelectorAll('.sf-dialog').forEach(dialog=>{
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>document.getElementById(dialog.dataset.opener)?.focus());
  });
  init();
  document.addEventListener('shopify:section:load',e=>{init(e.target);headerState();});
})();
